export interface IPersonSummary {
  ggId: string;
  username: string;
  subjectId?: string;
  name: string;
  professionalHeadline?: string;
  theme?: string;
  picture?: string;
  weight: number;
}

export class PersonSummary  {
  public ggId: string;
  public username: string;
  public subjectId?: string;
  public name: string;
  public professionalHeadline?: string;
  public theme?: string;
  public picture?: string;
  public weight: number;

  constructor(data: IPersonSummary, resizePicture: boolean = false) {
    this.ggId = data.ggId;
    this.username = data.username;
    this.subjectId = data.subjectId;
    this.name = data.name;
    this.professionalHeadline = data.professionalHeadline;
    this.theme = data.theme;
    this.picture = resizePicture && data.picture ? this.resizePicture(data.picture) : data.picture;
    this.weight = data.weight;
  }

  public firstName(): string {
    return this.name ? this.name.replace(/ .*/, "") : "";
  }

  private resizePicture(picture: string): string {
    if (picture.includes("cloudinary")) {
      return picture.replace("/upload/", "/upload/w_50,dpr_1.0/");
    }
    return picture;
  }
}
